/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentReportQueryWorkloadId extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentReportQueryWorkloadId");
    }

    getFixupPrototypeFunction() { return AssessmentReportQueryWorkloadId.fixupPrototype; }

    static newInstance(model: Partial<AssessmentReportQueryWorkloadId>): AssessmentReportQueryWorkloadId {
        let obj = Object.assign(new AssessmentReportQueryWorkloadId(), model);
        AssessmentReportQueryWorkloadId.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentReportQueryWorkloadId>): AssessmentReportQueryWorkloadId {
        if (!model) return null;
        return AssessmentReportQueryWorkloadId.newInstance(<AssessmentReportQueryWorkloadId> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentReportQueryWorkloadId) {
        if (!obj) return;

        models.AssessmentReportQueryWorkloadId.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentReportQueryWorkloadId): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentReportQueryWorkloadId.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of Workload
     */
    workload_ids: Array<string>;

}
